import { render, staticRenderFns } from "./AppHome.vue?vue&type=template&id=3b05d21c"
import script from "./AppHome.vue?vue&type=script&lang=js"
export * from "./AppHome.vue?vue&type=script&lang=js"
import style0 from "./AppHome.vue?vue&type=style&index=0&id=3b05d21c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports